const Strings = {
  CALENDAR_LANGUAGE: {
    SE: 'sv-SV',
    EN: 'en-US'
  },
  SELECT_BOOKING_SYSTEM: {
    SE: 'Välj bokningssystem',
    EN: 'Select booking system'
  },
  NO_BOOKING_SYSTEMS: {
    SE: 'Det finns inga bokningssystem.',
    EN: 'There are no booking systems.'
  },
  BOOK: {
    SE: 'Boka',
    EN: 'Book'
  },
  MY: {
    SE: 'Mina',
    EN: 'My'
  },
  BOOKINGS: {
    SE: 'bokningar',
    EN: 'bookings'
  },
  NO_BOOKING_SYSTEMS_ADMIN: {
    SE:
      'Inga bokningssystem har skapats, tryck på "förenings inställningar" för att skapa ett bokningssystem.',
    EN:
      'No booking systems has been created, press "association settings" to create a booking system.'
  }
}

export default Strings



// WEBPACK FOOTER //
// ./src/components/pages/bookingSystems/MyBookings/strings.js